import React, { Fragment, useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../axios";
import { btcDepositsUpdated } from "../../reducers/BTCDepositSlice";
import { setCookie } from "cookies-next";

const DepositRequestTable: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const requests = useSelector((state: any) => state.btcDeposits.btcDeposits);
  const deleteRequest = async (id: string, e:React.SyntheticEvent) => {
    e.preventDefault();
    try {
      const res = await axios.delete("/deleteBtcDepositRequest/" + id);
      console.log(res.data);
      dispatch(btcDepositsUpdated(res.data));
    } catch (err) {
      console.log("error", err);
    }
  };

  const redemeRequest = async (id: string, e: React.SyntheticEvent, amount: string, _id:string) => {
    e.preventDefault();
    let Amount: Number = Number(amount);
    try {
      const res = await axios.put("/redemeBtcDepositRequest/" + id, {
        amount: Amount,
        _id: _id
      });
      // setCookie("user", res.data, { maxAge: 60 * 60 * 2 });
    } catch (err) {}
  };

  useEffect(() => {
    axios.get("/getBtcDepositRequests").then((res) => {
      dispatch(btcDepositsUpdated(res.data));
    });
  }, [requests]);

  const tableData = requests?.map((info: any) => {
    console.log(info);
    const paymentTime = new Date().getHours() - 3;
    // new Date(info.createdAt).getHours();
    const currentTime = new Date().getHours();
    const interval = Math.abs(currentTime - paymentTime);
    return (
      <tr>
        <td>{info.username}</td>
        <td>{info.wallet_address}</td>
        <td>{info.amount}</td>
        <td>{interval}</td>
        <td>{info.redemed ? "redemed" : "not redemed"}</td>
        <td>
          <button
            className="btn btn-sm btn-danger mr-1"
            onClick={(e) => deleteRequest(info._id, e)}
          >
            Delete
          </button>
          <button
            className="btn btn-sm btn-success "
            disabled={info.redemed}
            onClick={(e) => redemeRequest(info.id, e, info.amount, info._id)}
          >
            {info.redemed?"Redeemed": "Redeme"}
          </button>
        </td>
      </tr>
    );
  });
  // 

  return (
    <Fragment>
      <section className="hero-section" style={{ height: "10vh" }}>
        <div className="container">
          <h1 className=" text-center text-white">BTC Deposit Requests</h1>
        </div>
      </section>

      <section id="about" className="about-section pt-150 pb-20">
        <div className="container">
          <div className="over-next">
            <table className="table ">
              <thead>
                <tr>
                  <th scope="col">USERNAME</th>
                  <th scope="col">ADDRESS</th>
                  <th scope="col">AMOUNT</th>
                  <th scope="col">TIME</th>
                  <th scope="col">STATUS</th>
                  <th scope="col">ACTION</th>
                </tr>
              </thead>
              <tbody>{tableData}</tbody>
            </table>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default DepositRequestTable;
